import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { KbaResponse } from '../../model/kbaresponse';
import { Injectable } from '@angular/core';
import { CommonConstants } from '../../../../../common/constants/common-constants';
import 'rxjs/add/operator/catch';

@Injectable()
export class RelatedKnowledgeBaseService {
    constructor(public http: HttpClient) { }

    public getArticleTitles(kbaId: number, limit: number): Observable<KbaResponse> {
        const params = new HttpParams()
            .set('limit', limit.toString());

        return this.http.post<KbaResponse>(CommonConstants.SERVICE_VERSION_PATH_V1 +
            '/customer/kbas/' + kbaId + '/relatedKbas', { params })
            .catch(this.handleError);
    }

    public getrelatedSoltionArticleTitles(requestNumber: number, limit: number): Observable<KbaResponse> {
        const params = new HttpParams()
            .set('limit', limit.toString());

        return this.http.post<KbaResponse>(CommonConstants.SERVICE_VERSION_PATH_V1 +
            '/customer/requests/' + requestNumber + '/solution/relatedKbas', { params })
            .catch(this.handleError);
    }

    handleError(error: Response) {
        console.error(error);
        return throwError(error);
    }
}





